import { FeatureFlagsState } from '../types';

export const FEATURE_FLAGS_UPDATED = 'kindbody/kb-shared/FEATURE_FLAGS_UPDATED';
export const FEATURE_FLAGS_ADDED = 'kindbody/kb-shared/FEATURE_FLAGS_ADDED';

export interface FeatureFlag {
  flagKey: string;
  value: string;
  description: string;
}

function addToFeatureMap(
  features: FeatureFlag[],
  map: Record<string, string>
): Record<string, string> {
  features.forEach(feature => {
    map[feature.flagKey] = feature.value;
  });
  return map;
}

export interface FeatureFlagsAction {
  type?: typeof FEATURE_FLAGS_UPDATED | typeof FEATURE_FLAGS_ADDED;
  features?: FeatureFlag[];
  featureFlags?: Record<string, string>;
}

export const INITIAL_STATE: FeatureFlagsState = {
  features: {}
};

export default function featureFlags(
  state: FeatureFlagsState = INITIAL_STATE,
  action: FeatureFlagsAction = {}
) {
  const { type, featureFlags, features } = action;
  switch (type) {
    case FEATURE_FLAGS_UPDATED:
      if (!featureFlags) return state;
      return {
        ...state,
        features: featureFlags
      };
    case FEATURE_FLAGS_ADDED:
      if (!features) return state;
      return {
        ...state,
        features: addToFeatureMap(features, state.features)
      };
    default:
      return state;
  }
}

export function featureFlagsRetrieved(featureFlags: Record<string, string>) {
  return { type: FEATURE_FLAGS_UPDATED, featureFlags };
}

export function featureFlagsAdded(features: Array<FeatureFlag>) {
  return { type: FEATURE_FLAGS_ADDED, features };
}
